module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.6.0 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/calendar.html"
    }
  }, [_vm._v("Calendar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] support prop:show-popup-header")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/checker.html"
    }
  }, [_vm._v("Checker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix event:on-change do not fire when using :value binding instead of v-model #1945")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/datetime.html"
    }
  }, [_vm._v("Datetime")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix i18n for cancel_text confirm_text")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/grid.html"
    }
  }, [_vm._v("Grid")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] prop:rows is deprecated #1971")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/inline-calendar.html"
    }
  }, [_vm._v("InlineCalendar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] (beta) Support prop:marks to style specified date item")]), _vm._v(" "), _c('li', [_vm._v("[fix] fix i18n for days")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/load-more.html"
    }
  }, [_vm._v("LoadMore")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix `tip` is empty and `show-loading` is `false`, the background color is not correct")]), _vm._v(" "), _c('li', [_vm._v("[feature] support less variable @load-more-tip-background-color")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/panel.html"
    }
  }, [_vm._v("Panel")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] support list prop:fallbackSrc #1923")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popup-radio.html"
    }
  }, [_vm._v("PopupRadio")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix placeholder logic #1964")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/swiper.html"
    }
  }, [_vm._v("Swiper")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] support fallbackImg for prop:list #1923")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-dialog.html"
    }
  }, [_vm._v("XDialog")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix body still scrolls when scrolling on dialog")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-img.html"
    }
  }, [_vm._v("XImg")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] re-initialize when src is changed #1901")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-52139473", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-52139473"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.6.0-123.vue
// module id = 2241
// module chunks = 265